<chapter-step
  [title]="'Restrict clock-ins to a specific location' | translate"
  [nextButtonLabel]="'Save and continue' | translate"
  [nextButtonLoading]="nextButtonLoading"
  [skipButtonLoading]="skipButtonLoading"
  [skipButtonLabel]="'Skip' | translate"
  [showSkipButton]="true"
  [nextButtonDisabled]="!selectedLocationMarker"
  (next)="onNext()"
  (skip)="skip.emit()"
>
  <p class="m-0 text-base">
    {{
      'Specify where employees can clock in and out. This ensures accurate attendance tracking by restricting clock-ins to approved work sites only.'
        | translate
    }}
  </p>
  <sb-form-field [label]="'Address' | translate">
    <input #addressInput type="text" sbInput />
  </sb-form-field>
  <sb-maps
    class="h-72 overflow-hidden rounded-lg lg:hidden"
    [latitude]="selectedLocationMarker?.lat"
    [longitude]="selectedLocationMarker?.lng"
    [markers]="selectedLocationMarker && [selectedLocationMarker]"
    [fitMarkerBounds]="!!selectedLocationMarker"
    [zoom]="17"
    [defaultHeight]="false"
    [iteractable]="false"
  />
</chapter-step>
